import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Users, FileText, Briefcase } from 'lucide-react';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const services = [
    {
      icon: Users,
      title: 'IT Staffing',
      description: 'Requirement intake through vendor/MSP channels with resume screening and interview coordination support.'
    },
    {
      icon: FileText,
      title: 'Contract Workforce (CW)',
      description: 'Contract engagement support aligned with vendor processes, including timesheet and billing coordination.'
    },
    {
      icon: Briefcase,
      title: 'Professional Consulting',
      description: 'Consulting delivered under defined scope of work through vendor-to-vendor engagements.'
    }
  ];

  const operatingSummary = [
    'Vendor-to-vendor engagements only',
    'Compliance-first processes',
    'Remote delivery model; registered in India'
  ];

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className={`relative bg-gradient-to-br from-slate-50 to-gray-100 transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              IT Staffing | Contract Workforce | Professional Consulting
            </h1>
            <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
              Vendor-to-vendor staffing and professional services for enterprise, MSP, and staffing partners.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-8 py-3 bg-blue-900 text-white font-medium rounded hover:bg-blue-800 transition-colors shadow-md hover:shadow-lg"
              >
                Contact Us
                <ArrowRight size={20} className="ml-2" />
              </Link>
              <Link
                to="/engagement-model"
                className="inline-flex items-center justify-center px-8 py-3 bg-white text-blue-900 font-medium rounded border-2 border-blue-900 hover:bg-blue-50 transition-colors"
              >
                Engagement Model
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-4xl mx-auto space-y-6 text-center">
          <p className="text-lg text-gray-700 leading-relaxed">
            BRX Resource is an India-registered provider of IT staffing, contract workforce support, resource augmentation, and professional consulting services. We operate through structured, documentation-driven vendor-to-vendor engagements.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            Services are provided subject to written agreements, applicable approvals, and mutually agreed commercial terms.
          </p>
        </div>
      </section>

      {/* Services Snapshot */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Services Snapshot</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const IconComponent = service.icon;
              return (
                <div
                  key={index}
                  className="bg-white p-8 rounded-lg border border-gray-200 hover:shadow-lg transition-shadow duration-300"
                >
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                    <IconComponent size={24} className="text-blue-900" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Operating Summary */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Operating Summary</h2>
          <div className="space-y-4">
            {operatingSummary.map((item, index) => (
              <div key={index} className="flex items-start">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                <p className="text-lg text-gray-700">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;